import {
  Autocomplete,
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef, useMemo } from "react";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import CommonButton from "../../../../Componants/Common/Button";
import Subheader from "../../../../Componants/Common/Subheader";
import InputFileUpload from "../../../../Componants/Common/Bulk Upload/InputFileUpload";
import CustomDatePicker from "../../../../Componants/Common/Custom Date Picker/CustomDatePicker";
import { useNavigate } from "react-router-dom";
import LogcomplaintIcon from "../../../../Assests/logComplaintIcon.svg";
import { width } from "@mui/system";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../../Componants/Loader/Loader";
import { Calendar } from "../../../../Componants/Common/Calender";
import {
  customers,
  customerProduct,
  getCountryListDrop,
  getStateListDrop,
  getCityListDrop,
  createCustomers,
  fetchBrandListDropdown,
  fetchCategoryListDropdown,
  fetchSubCategoryListDropdown,
  fetchModelListDropdown,
  addProduct,
  updateCustomers,
  logProductComplaint,
  getServiceCentreList,
  customersById,
  multiImageUpload,
  singleImageUpload,
  fetchServiceCenterDetails,
  fetchAMCList,
  fetchJobsheetSearchList,
} from "../../../../API Service/apiService";
import deleteIcon from "../../../../Assests/deleteIcon.svg";
import DynamicTabs from "../../../../components/DynamicTabs";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Tooltip } from "@material-ui/core";
import { formatAnyDateToDisplay, formatDateInIST } from "../../../../utils/dateFormatter";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = dateString.$d ? dateString.$d : new Date(dateString);
  if (isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const customerCells = [
  "Name",
  "State",
  "City",
  "Mobile",
  "Address",
  "Email",
  "Edit",
  "Action",
  "ViewProduct",
];


const productCells = [
  "Brand",
  "Category",
  "Subcategory",
  "Model",
  "Date of Purchase",
  "Invoice",
  "Action",
];

const callCells = [
  "Jobsheet Date",
  "Jobsheet No.",
  "Complaint No.",
  "Product Category",
  "Model",
  "SKU",
  "Contact Person",
  "Jobsheet Status",
];


const modalCell = [
  "Location",
  "Serive Center Name",
  "Address",
  "Contact No.",
  "Email",
];


const options = [
  { label: "Option 1" },
  { label: "Option 2" },
  { label: "Option 3" },
];
// const jobsheet = [{ label: "Repair" }, { label: "Replacement" }];

const serviceType = [{ label: "On-site",id:1 }, { label: "In-store",id:2 },{ label: "Remote",id:3 }];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#EFF3FE",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const ProductModal = ({ customerId, onClose, handleSearchProduct }) => {
  const [value, setValue] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [activeBrandList, setActiveBrandList] = useState([]);
  const [selectedBrandId, setSelectedBrandId] = useState(null);
  const [filteredCat, setFilteredCat] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [filteredSubCat, setFilteredSubCat] = useState([]);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);
  const [filteredModel, setFilteredModel] = useState([]);
  const [selectedModelId, setSelectedModelId] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [invoiceImageFiles, setInvoiceImageFiles] = useState([]);
  const [invoiceImages, setInvoiceImages] = useState([]);
  const [imageValue, setImageValue] = useState([]);
  const [formValues, setFormValues] = useState({
    invoiceNo: "",
    serialNo: "",
    purchasedFrom: "",
  });
  const [formErrors, setFormErrors] = useState({
    brandId: "",
    categoryId: "",
    subcategoryId: "",
    modelId: "",
    invoiceDate: "",
    invoiceNo: "",
    serialNo: "",
    purchasedFrom: "",
  });
  const [touched, setTouched] = useState({
    invoiceNo: false,
    serialNo: false,
    purchasedFrom: false,
  });

  useEffect(() => {
    fetchBrandList();
  }, []);

  useEffect(() => {
    if (selectedBrandId) fetchCategoriesList();
  }, [selectedBrandId]);

  useEffect(() => {
    if (selectedCategoryId) fetchSubCategoriesList();
  }, [selectedCategoryId]);

  useEffect(() => {
    if (selectedSubCategoryId) fetchModelsList();
  }, [selectedSubCategoryId]);

  const fetchBrandList = async () => {
    try {
      setLoading(true);
      const response = await fetchBrandListDropdown({ dropdown: true });
      const activeBrands = response.data.brandList.filter(
        (brand) => brand.active
      );
      setActiveBrandList(activeBrands);
    } catch (error) {
      console.error("Error fetching brand list:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategoriesList = async () => {
    if (!selectedBrandId) return;
    try {
      setLoading(true);
      const response = await fetchCategoryListDropdown(selectedBrandId);
      setFilteredCat(response.data.categories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubCategoriesList = async () => {
    try {
      setLoading(true);
      const response = await fetchSubCategoryListDropdown({
        brandId: selectedBrandId,
        categoryId: selectedCategoryId,
        dropdown: true,
      });
      setFilteredSubCat(response.data.subcategory);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchModelsList = async () => {
    try {
      setLoading(true);
      const response = await fetchModelListDropdown({
        brandId: selectedBrandId,
        categoryId: selectedCategoryId,
        subcategoryId: selectedSubCategoryId,
        dropdown: true,
      });
      setFilteredModel(response.data.models);
    } catch (error) {
      console.error("Error fetching models:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleChange = (fieldName, date) => {

    if (fieldName === "invoiceDate") {
      setInvoiceDate(date); // Store the original date object
      setFormErrors({ ...formErrors, invoiceDate: "" });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    let updatedValue = value;

    // Validate invoice number
    if (name === "invoiceNo") {
      if (value && !/^[a-zA-Z0-9]+$/.test(value)) {
        error = "Invoice number must be alphanumeric only";
      } else if (value.length > 50) {
        updatedValue = value.slice(0, 50);
        error = "Invoice number must be at most 50 characters";
      }
    }

    // Validate serial number
    else if (name === "serialNo") {
      if (value && !/^[a-zA-Z0-9]+$/.test(value)) {
        error = "Serial number must be alphanumeric only";
      } else if (value.length > 15) {
        updatedValue = value.slice(0, 15);
        error = "Serial number must be at most 15 characters";
      }
    }

    // Validate purchased from
    else if (name === "purchasedFrom") {
      if (value.length > 50) {
        updatedValue = value.slice(0, 50);
        error = "Must be at most 50 characters";
      }
    }

    setFormValues({
      ...formValues,
      [name]: updatedValue,
    });

    setFormErrors({
      ...formErrors,
      [name]: error,
    });
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched({
      ...touched,
      [name]: true,
    });
  };

  const handleInvoiceImageChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length + invoiceImageFiles.length > 3) {
      toast.error("You can only upload up to 3 images");
      return;
    }

    // Optional: Add file size check
    const maxSize = 5 * 1024 * 1024; // 5MB
    const invalidFiles = files.filter((file) => file.size > maxSize);
    if (invalidFiles.length > 0) {
      toast.error("Some files are too large. Maximum size is 5MB per file.");
      return;
    }

    const newImages = files.map((file) => URL.createObjectURL(file));
    setInvoiceImages((prevImages) => [...prevImages, ...newImages]);
    setInvoiceImageFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const handleInvoiceImageDelete = (index) => {
    // Revoke the URL to prevent memory leaks
    URL.revokeObjectURL(invoiceImages[index]);

    setInvoiceImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setInvoiceImageFiles((prevFiles) =>
      prevFiles.filter((_, i) => i !== index)
    );
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    // Validate required fields
    const requiredFields = {
      brandId: { value: selectedBrandId, label: "Brand" },
      categoryId: { value: selectedCategoryId, label: "Category" },
      subcategoryId: { value: selectedSubCategoryId, label: "Sub Category" },
      modelId: { value: selectedModelId, label: "Model" },
      invoiceDate: { value: invoiceDate, label: "Invoice Date" },
    };

    Object.entries(requiredFields).forEach(([key, field]) => {
      if (!field.value) {
        errors[key] = `${field.label} is required`;
        isValid = false;
      }
    });

    // Validate invoice number
    if (formValues.invoiceNo && !/^[a-zA-Z0-9]+$/.test(formValues.invoiceNo)) {
      errors.invoiceNo = "Invoice number must be alphanumeric only";
      isValid = false;
    }

    // Validate serial number
    // Validate serial number
    if (formValues.serialNo && !/^[a-zA-Z0-9]+$/.test(formValues.serialNo)) {
      errors.serialNo = "Serial number must be alphanumeric only";
      isValid = false;
    } else if (formValues.serialNo && formValues.serialNo.length > 15) {
      errors.serialNo = "Serial number must be at most 15 characters";
      isValid = false;
    }

    // Validate purchased from
    if (formValues.purchasedFrom && formValues.purchasedFrom.length > 50) {
      errors.purchasedFrom = "Purchased from cannot exceed 50 characters";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleCreateProduct = async (e) => {
    if (e) e.preventDefault();

    if (!validateForm()) {
      // toast.error("Please fix the validation errors before submitting");
      return;
    }

    const storedCustomerId = localStorage.getItem("customerId");
    const currentCustomerId = customerId || storedCustomerId;

    if (!currentCustomerId) {
      toast.error(
        "Customer ID not found. Please select or create a customer first."
      );
      return;
    }

    try {
      setLoading(true);

      // Upload invoice images if any
      let imagePath = [];

      if (
        invoiceImageFiles &&
        invoiceImageFiles.length > 0 &&
        imageValue.length === 0
      ) {
        const invoiceFormData = new FormData();
        invoiceFormData.append("imageType", "invoice");

        for (const file of invoiceImageFiles) {
          invoiceFormData.append("image", file);
        }

        try {
          const invoiceImagesResponse = await singleImageUpload(
            invoiceFormData
          );
          if (
            invoiceImagesResponse.data &&
            invoiceImagesResponse.data.status === "success"
          ) {
            imagePath = invoiceImagesResponse.data.data.fullPath;
            setImageValue(imagePath);
          } else {
            throw new Error(
              invoiceImagesResponse.data?.message ||
              "Failed to upload invoice images"
            );
          }
        } catch (error) {
          console.error("Error uploading invoice images:", error);
          toast.error(error.message || "Failed to upload invoice images");
          setLoading(false);
          return;
        }
      }

      const body = {
        customerId: currentCustomerId,
        brandId: selectedBrandId,
        categoryId: selectedCategoryId,
        subcategoryId: selectedSubCategoryId,
        modelId: selectedModelId,
        invoiceNo: formValues.invoiceNo,
        invoiceDate: formatDate(invoiceDate),
        serialNo: formValues.serialNo,
        purchasedFrom: formValues.purchasedFrom,
        imagePath: imagePath.length > 0 ? imagePath : imageValue,
      };

      const response = await addProduct(body);

      if (!response || response.status !== "success") {
        throw new Error(response?.message || "Failed to create product");
      }

      toast.success(response.message || "Product created successfully");

      // Refresh the product list using the passed function
      await handleSearchProduct(currentCustomerId);

      resetProductForm();
      onClose();
    } catch (error) {
      console.error("Error creating product:", error);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Failed to create product"
      );
    } finally {
      setLoading(false);
    }
  };

  const resetProductForm = () => {
    // Cleanup URLs before resetting
    invoiceImages.forEach((url) => URL.revokeObjectURL(url));

    setFormValues({
      invoiceNo: "",
      serialNo: "",
      purchasedFrom: "",
    });
    setFormErrors({
      brandId: "",
      categoryId: "",
      subcategoryId: "",
      modelId: "",
      invoiceDate: "",
      invoiceNo: "",
      serialNo: "",
      purchasedFrom: "",
    });
    setTouched({
      invoiceNo: false,
      serialNo: false,
      purchasedFrom: false,
    });
    setSelectedBrandId(null);
    setSelectedCategoryId(null);
    setSelectedSubCategoryId(null);
    setSelectedModelId(null);
    setInvoiceDate(null);
    setInvoiceImages([]);
    setInvoiceImageFiles([]);
  };

  return (
    <Box sx={{ ...style, width: "75%", maxHeight: "60vh", overflow: "auto" }}>
      {loading && <Loader />}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Product Details</span>
        <IconButton
          onClick={onClose}
          sx={{
            backgroundColor: "#EFF3FE",
            color: "#33499F",
            border: "none",
            borderRadius: "4px",
            padding: "4px",
            "&:hover": {
              backgroundColor: "#EFF3FE",
            },
          }}
        >
          <span style={{ fontSize: "20px", fontWeight: "bolder" }}>✕</span>
        </IconButton>
      </Box>
      <form onSubmit={handleCreateProduct}>
        <Grid container mt="3" spacing={4}>
          <Grid item>
            <Autocomplete
              id="disable-close-on-select"
              options={activeBrandList}
              getOptionLabel={(option) => option.brandName || ""}
              value={
                activeBrandList.find(
                  (brand) => brand._id === selectedBrandId
                ) || null
              }
              onChange={(event, newValue) => {
                setSelectedBrandId(newValue?._id || null);
                setFormErrors({ ...formErrors, brandId: "" });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brand *"
                  variant="standard"
                  style={{ width: "12.5rem" }}
                  error={!!formErrors.brandId}
                  helperText={formErrors.brandId}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              id="disable-close-on-select"
              options={filteredCat}
              getOptionLabel={(option) => option.categoryName || ""}
              value={
                filteredCat.find((cat) => cat._id === selectedCategoryId) ||
                null
              }
              onChange={(event, newValue) => {
                setSelectedCategoryId(newValue?._id || null);
                setFormErrors({ ...formErrors, categoryId: "" });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category *"
                  variant="standard"
                  style={{ width: "12.5rem" }}
                  error={!!formErrors.categoryId}
                  helperText={formErrors.categoryId}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              id="disable-close-on-select"
              options={filteredSubCat}
              getOptionLabel={(option) => option.subcategoryName || ""}
              value={
                filteredSubCat.find(
                  (sub) => sub._id === selectedSubCategoryId
                ) || null
              }
              onChange={(event, newValue) => {
                setSelectedSubCategoryId(newValue?._id || null);
                setFormErrors({ ...formErrors, subcategoryId: "" });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sub Category *"
                  variant="standard"
                  style={{ width: "12.5rem" }}
                  error={!!formErrors.subcategoryId}
                  helperText={formErrors.subcategoryId}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              id="disable-close-on-select"

              options={filteredModel}
              getOptionLabel={(option) => option.modelName || ""}
              value={
                filteredModel.find((model) => model._id === selectedModelId) ||
                null
              }
              onChange={(event, newValue) => {
                setSelectedModelId(newValue?._id || null);
                setFormErrors({ ...formErrors, modelId: "" });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Model *"
                  variant="standard"
                  style={{ width: "12.5rem" }}
                  error={!!formErrors.modelId}
                  helperText={formErrors.modelId}
                />
              )}
            />
          </Grid>
          <Grid item md={3}>
            <Calendar
              value={invoiceDate}
              handleChange={handleChange}
              fieldName="invoiceDate"
              label="Invoice Date *"
              error={!!formErrors.invoiceDate}
              helperText={formErrors.invoiceDate}
              withPortal={true}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="invoiceNo"
              name="invoiceNo"
              label="Invoice No."
              variant="standard"
              value={formValues.invoiceNo}
              onChange={handleInputChange}
              onBlur={handleBlur}
              error={touched.invoiceNo && Boolean(formErrors.invoiceNo)}
              helperText={touched.invoiceNo && formErrors.invoiceNo}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="serialNo"
              name="serialNo"
              label="Serial No."
              variant="standard"
              value={formValues.serialNo}
              onChange={handleInputChange}
              onBlur={handleBlur}
              error={touched.serialNo && Boolean(formErrors.serialNo)}
              helperText={touched.serialNo && formErrors.serialNo}
              inputProps={{ maxLength: 15 }}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="purchasedFrom"
              name="purchasedFrom"
              label="Purchased From"
              variant="standard"
              value={formValues.purchasedFrom}
              onChange={handleInputChange}
              onBlur={handleBlur}
              error={touched.purchasedFrom && Boolean(formErrors.purchasedFrom)}
              helperText={touched.purchasedFrom && formErrors.purchasedFrom}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item>
            <Grid item xs={12} sm={12} md={12}>
              <input
                type="file"
                onChange={handleInvoiceImageChange}
                accept=".jpg, .png, .svg"
                multiple
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  border: "none",
                  outline: "none",
                  width: "100%",
                  maxWidth: "300px",
                  fontSize: "14px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                }}
              />
            </Grid>

            {invoiceImageFiles.length > 0 && (
              <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#1976d2" }}>
                      <TableCell sx={{ color: "white" }}>S.No</TableCell>
                      <TableCell sx={{ color: "white" }}>File</TableCell>
                      <TableCell sx={{ color: "white" }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoiceImageFiles.map((file, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.name}</TableCell>
                        <TableCell>
                          <IconButton
                            onClick={() => handleInvoiceImageDelete(index)}
                            sx={{
                              outline: "none",
                              "&:focus": { outline: "none" },
                            }}
                          >
                            <img
                              src={deleteIcon}
                              alt="delete"
                              height="20px"
                              width="20px"
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
        <Grid container justifyContent={"flex-end"} gap={2}>
          <Grid item>
            <CommonButton
              type="submit"
              name={"Create"}
              handleOnClick={handleCreateProduct}
            />
          </Grid>
          <Grid item>
            <CommonButton name={"Cancel"} handleOnClick={resetProductForm} />
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

const CustomerModal = ({ customerData, isEdit, onClose, onUpdate }) => {
  const [value, setValue] = useState();
  const [countriesActive, setCountriesActive] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const [countryId, setCountryId] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [cityId, setCityId] = useState(null);

  const [loading, setLoading] = useState(false);
  const formikRef = useRef(null);

  const validationSchema = Yup.object({
    customerName: Yup.string()
      .required("Customer name is required")
      .max(25, "Customer name must be at most 25 characters"),
    mobileNumber: Yup.string()
      .required("Mobile number is required")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
      .test("is-numeric", "Mobile number must contain only numbers", (value) =>
        /^\d+$/.test(value)
      ),
    email: Yup.string()
      .required("Email is required")
      .email("Invalid email format")
      .max(50, "Email must be at most 50 characters"),
    address: Yup.string().required("Address is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
    pincode: Yup.string().required("Pin code is required"),
    // gstNumber: Yup.string().required("GST number is required"),
  });

  const initialValues = {
    customerName: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    landmark: "",
    gstNumber: "",
  };

  useEffect(() => {
    fetchCountries(); // Fetch countries on component load
  }, []);

  useEffect(() => {
    if (isEdit && customerData) {
      // Set selected country, state, and city when editing
      const country = countriesActive.find(
        (c) => c.countryName === customerData.country
      );
      if (country) {
        setSelectedCountry(country);
        setCountryId(country._id);
      }
    }
  }, [isEdit, customerData, countriesActive]);

  useEffect(() => {
    if (selectedCountry) fetchStates(selectedCountry._id); // Fetch states when a country is selected
  }, [selectedCountry]);

  useEffect(() => {
    if (isEdit && customerData && states.length > 0) {
      // Set selected state when editing and states are loaded
      const state = states.find((s) => s.stateName === customerData.state);
      if (state) {
        setSelectedState(state);
        setStateId(state._id);
      }
    }
  }, [isEdit, customerData, states]);

  useEffect(() => {
    if (selectedState) fetchCities(selectedState._id); // Fetch cities when a state is selected
  }, [selectedState]);

  useEffect(() => {
    if (isEdit && customerData && cities.length > 0) {
      // Set selected city when editing and cities are loaded
      const city = cities.find((c) => c.cityName === customerData.city);
      if (city) {
        setSelectedCity(city);
        setCityId(city._id);
      }
    }
  }, [isEdit, customerData, cities]);

  const fetchCountries = async () => {
    try {
      setLoading(true);
      const response = await getCountryListDrop({ dropdown: true });
      setCountriesActive(response.data.countries);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStates = async () => {
    try {
      setLoading(true);
      const response = await getStateListDrop({ countryId, dropdown: true });
      setStates(response.data.states);
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCities = async () => {
    try {
      setLoading(true);
      const response = await getCityListDrop({
        stateId,
        countryId,
        dropdown: true,
      });
      setCities(response.data.cities);
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveCustomer = async (values, { setSubmitting }) => {
    try {
      setLoading(true);
      let response;
      if (isEdit) {
        response = await updateCustomers(customerData.customerId, values);
      } else {
        response = await createCustomers(values);
      }

      if (!response || response.status !== "success") {
        throw new Error(
          response?.message ||
          `Failed to ${isEdit ? "update" : "create"} customer`
        );
      }

      toast.success(
        response.message ||
        `Customer ${isEdit ? "updated" : "created"} successfully`
      );
      onUpdate();
      onClose();
    } catch (error) {
      console.error("Error saving customer:", error);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        `Failed to ${isEdit ? "update" : "create"} customer`
      );
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const handleCancelCustomer = async () => {
    console.log("cancel customer button clicked");
    if (formikRef.current) {
      formikRef.current.resetForm();
    }
    setSelectedCountry(null);
    setSelectedState(null);
    setSelectedCity(null);
    setCountryId(null);
    setStateId(null);
    setCityId(null);
  };

  return (
    <Box sx={{ ...style, width: "75%" }}>
      {loading && <Loader />}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h4>{isEdit ? "Update Customer" : "Create Customer"}</h4>
        <IconButton
          onClick={onClose}
          sx={{
            backgroundColor: "#EFF3FE",
            color: "#33499F",
            border: "none",
            borderRadius: "4px",
            padding: "4px",
            "&:hover": {
              backgroundColor: "#EFF3FE",
            },
          }}
        >
          <span style={{ fontSize: "20px", fontWeight: "bolder" }}>✕</span>
        </IconButton>
      </Box>

      <Formik
        initialValues={isEdit && customerData ? customerData : initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSaveCustomer}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize
        innerRef={formikRef}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <Form>
            <Grid container spacing={5}>
              <Grid item>
                <TextField
                  style={{ width: "100%" }}
                  id="customerName"
                  name="customerName"
                  label="Customer Name"
                  variant="standard"
                  value={values.customerName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.customerName && Boolean(errors.customerName)}
                  helperText={touched.customerName && errors.customerName}
                  inputProps={{
                    maxLength: 25,
                  }}
                />
              </Grid>

              <Grid item>
                <TextField
                  style={{ width: "100%" }}
                  id="mobileNumber"
                  name="mobileNumber"
                  label="Mobile No."
                  variant="standard"
                  value={values.mobileNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.mobileNumber && Boolean(errors.mobileNumber)}
                  helperText={touched.mobileNumber && errors.mobileNumber}
                  inputProps={{
                    maxLength: 10,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                  }}
                />
              </Grid>
              <Grid item>
                <TextField
                  style={{ width: "100%" }}
                  id="email"
                  name="email"
                  label="Email"
                  variant="standard"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                  inputProps={{
                    maxLength: 50,
                  }}
                />
              </Grid>
              <Grid item>
                <Autocomplete
                  id="country"
                  options={countriesActive}
                  getOptionLabel={(option) => option.countryName || ""}
                  value={selectedCountry}
                  onChange={(event, newValue) => {
                    setSelectedCountry(newValue);
                    setFieldValue("country", newValue?.countryName || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="country"
                      label="Country"
                      variant="standard"
                      style={{ width: "12.5rem" }}
                      error={touched.country && Boolean(errors.country)}
                      helperText={touched.country && errors.country}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container mt="3" spacing={4}>
              <Grid item>
                <Autocomplete
                  id="state"
                  options={states}
                  getOptionLabel={(option) => option.stateName || ""}
                  value={selectedState}
                  onChange={(event, newValue) => {
                    setSelectedState(newValue);
                    setFieldValue("state", newValue?.stateName || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="state"
                      label="State"
                      variant="standard"
                      style={{ width: "12.5rem" }}
                      error={touched.state && Boolean(errors.state)}
                      helperText={touched.state && errors.state}
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Autocomplete
                  id="city"
                  options={cities}
                  getOptionLabel={(option) => option.cityName || ""}
                  value={selectedCity}
                  onChange={(event, newValue) => {
                    setSelectedCity(newValue);
                    setFieldValue("city", newValue?.cityName || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="city"
                      label="City"
                      variant="standard"
                      style={{ width: "12.5rem" }}
                      error={touched.city && Boolean(errors.city)}
                      helperText={touched.city && errors.city}
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <TextField
                  style={{ width: "100%" }}
                  id="address"
                  name="address"
                  label="Address"
                  variant="standard"
                  value={values.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.address && Boolean(errors.address)}
                  helperText={touched.address && errors.address}
                />
              </Grid>
              <Grid item>
                <TextField
                  style={{ width: "100%" }}
                  id="pincode"
                  name="pincode"
                  label="Pin Code"
                  variant="standard"
                  value={values.pincode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.pincode && Boolean(errors.pincode)}
                  helperText={touched.pincode && errors.pincode}
                />
              </Grid>
              <Grid item>
                <TextField
                  style={{ width: "100%" }}
                  id="landmark"
                  name="landmark"
                  label="Landmark"
                  variant="standard"
                  value={values.landmark}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Grid>
              <Grid item>
                <TextField
                  style={{ width: "100%" }}
                  id="gstNumber"
                  name="gstNumber"
                  label="GSTIN No."
                  variant="standard"
                  value={values.gstNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.gstNumber && Boolean(errors.gstNumber)}
                  helperText={touched.gstNumber && errors.gstNumber}
                />
              </Grid>
            </Grid>
            <Grid container justifyContent={"flex-end"} gap={2} mt={2}>
              <Grid item>
                <CommonButton
                  name={isEdit ? "Update" : "Create"}
                  type="submit"
                  disabled={isSubmitting}
                  handleOnClick={handleSubmit}
                />
              </Grid>
              <Grid item>
                <CommonButton
                  name={"Cancel"}
                  handleOnClick={handleCancelCustomer}
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

const LogComplaintModal = ({ customerId, customerProductId, amcStatus, onClose }) => {
  const [value, setValue] = useState();
  const [checked, setChecked] = useState(false);
  const [serviceCenterList, setServiceCenterList] = useState([]);
  const [loading, setLoading] = useState(false);
  const initialFormData = {
    jobsheetType: "",
    status: "Open",
    customerName: "",
    city: "",
    serviceType: "",
    serviceCenterId: "",
    faltObserverByCustomer: "",
    remarks: "",
    customerContactPerson: "",
    customerContactPersonNumber: "",
    preferredDate: "",
    preferredDateApi: "",
    preferredTime: "",
    callClose: false,
    solutionProvided: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [formErrors, setFormErrors] = useState({
    serviceType: "",
    serviceCenterId: "",
    preferredDate: "",
    startTime: "",
    endTime: "",
  });
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [serviceCenter, setServiceCenter] = useState([]);

  // Define jobsheet options based on amcStatus
  const jobsheetOptions = useMemo(() => {
    const baseOptions = [{ label: "Repair" }, { label: "Replacement" }];
    return amcStatus === "Running" ? [...baseOptions, { label: "AMC" }] : baseOptions;
  }, [amcStatus]);



  // Update the preferredTime whenever startTime or endTime changes
  useEffect(() => {
    if (startTime && endTime) {
      const formattedTime = `${startTime.format("HH:mm")} - ${endTime.format(
        "HH:mm"
      )}`;

      setFormData((prevData) => ({
        ...prevData,
        preferredTime: formattedTime, // Ensure correct update
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        preferredTime: "",
      }));
    }
  }, [startTime, endTime]); // Runs whenever startTime or endTime changes

  // Fetch customer details and service centers when the modal loads

  const getServiceCenterList = async () => {
    try {
      setLoading(true);
      const params = {
        serviceCenterId: formData.serviceCenterId,
      }
      const response = await fetchServiceCenterDetails(params);
      if (response.status === 200) {
        setServiceCenter(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching service center list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getServiceCenterList();
  }, [formData.serviceCenterId]);

  useEffect(() => {
    if (customerId && typeof customerId === "string") {
      fetchCustomerDetailsById();
      fetchCustomerServiceList();
    } else {
      console.error("Invalid customerId provided to LogComplaintModal.");
      toast.error("Invalid customerId. Unable to fetch data.");
    }
  }, [customerId]);

  const fetchCustomerDetailsById = async () => {
    try {
      setLoading(true);
      if (!customerId || typeof customerId !== "string") {
        toast.error("Invalid customerId. Unable to fetch customer details.");
        return;
      }

      const result = await customersById(customerId); // Pass only the string ID
      if (result.status === "success") {
        const customer = result.data;
        setFormData((prev) => ({
          ...prev,
          customerName: customer.customerName || "",
          city: customer.city || "",
        }));
      } else {
        toast.error(result.message || "Failed to fetch customer details");
      }
    } catch (error) {
      console.error("Error fetching customer details:", error);
      toast.error("An error occurred while fetching customer details");
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomerServiceList = async () => {
    try {
      setLoading(true);
      const result = await getServiceCentreList();
      if (result.status === "success") {
        setServiceCenterList(result.data.serviceCenters);
        // toast.success("Service centers fetched successfully");
      } else {
        toast.error(result.message || "Failed to fetch service centers");
      }
    } catch (error) {
      console.error("Error fetching service centers:", error);
      toast.error("An error occurred while fetching service centers");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (field === "serviceType" || field === "serviceCenterId" || field === "preferredDate") {
      setFormErrors((prev) => ({
        ...prev,
        [field]: value ? "" : prev[field],
      }));
    }

    if (field === "preferredDate" && !value) {
      setStartTime(null);
      setEndTime(null);
      setFormErrors((prev) => ({
        ...prev,
        startTime: "",
        endTime: "",
      }));
    }
  };

  const handlePreferredDateChange = (fieldName, value) => {
    const preferredDateApi = formatDateInIST(value, "DD-MM-YYYY", "");

    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
      preferredDateApi,
    }));

    setFormErrors((prev) => ({
      ...prev,
      preferredDate: value ? "" : prev.preferredDate,
    }));
  };

  const handleStartTimeChange = (newTime) => {
    if (!formData.preferredDate) {
      setFormErrors((prev) => ({
        ...prev,
        preferredDate: "Please select Date first",
        startTime: "Please select Date first",
      }));
      return;
    }

    setStartTime(newTime);
    setFormErrors((prev) => ({
      ...prev,
      preferredDate: "",
      startTime: newTime ? "" : prev.startTime,
      endTime: "",
    }));
    setEndTime(null);
  };

  const handleEndTimeChange = (newTime) => {
    if (!formData.preferredDate) {
      setFormErrors((prev) => ({
        ...prev,
        preferredDate: "Please select Date first",
        endTime: "Please select Date first",
      }));
      return;
    }

    if (!startTime) {
      setFormErrors((prev) => ({
        ...prev,
        startTime: "Please select Start Time first",
        endTime: "Please select Start Time first",
      }));
      return;
    }

    if (newTime && startTime && dayjs(newTime).isBefore(dayjs(startTime))) {
      setFormErrors((prev) => ({
        ...prev,
        endTime: "End Time cannot be earlier than Start Time",
      }));
      return;
    }

    setEndTime(newTime);
    setFormErrors((prev) => ({
      ...prev,
      endTime: "",
    }));
  };

  const validateForm = () => {
    const errors = {
      serviceType: formData.serviceType ? "" : "Service Type is required",
      serviceCenterId: formData.serviceCenterId ? "" : "Service Center is required",
      preferredDate: formData.preferredDate ? "" : "Date is required",
      startTime: startTime ? "" : "Start Time is required",
      endTime:
        !endTime
          ? "End Time is required"
          : dayjs(endTime).isBefore(dayjs(startTime))
            ? "End Time cannot be earlier than Start Time"
            : "",
    };

    setFormErrors(errors);
    return (
      !errors.serviceType &&
      !errors.serviceCenterId &&
      !errors.preferredDate &&
      !errors.startTime &&
      !errors.endTime
    );
  };

  const isPreferredDateToday =
    !!formData.preferredDate && dayjs(formData.preferredDate).isSame(dayjs(), "day");
  const currentTime = dayjs();
  const startTimeMinValue = isPreferredDateToday ? currentTime : undefined;
  const endTimeMinValue = startTime || (isPreferredDateToday ? currentTime : undefined);

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    console.log("formData",formData.preferredDate);

    const payload = {
      customerId,
      customerProductId,
      jobsheetType: formData.jobsheetType,
      status: formData.status,
      serviceCenterId: formData.serviceCenterId,
      serviceType: formData.serviceType,
      faltObserverByCustomer: formData.faltObserverByCustomer,
      remarks: formData.remarks,
      customerContactPerson: formData.customerContactPerson,
      customerContactPersonNumber: formData.customerContactPersonNumber,
      preferredDate: formData.preferredDateApi,
      preferredTime: formData.preferredTime,
      callClose: formData.callClose,
      solutionProvided: formData.callClose
        ? formData.solutionProvided
        : undefined,
    };

    try {
      setLoading(true);
      const result = await logProductComplaint(payload);
      if (result.status === "success") {
        // toast.success("Complaint logged successfully"); // Original toast
        toast.success(
          (t) => (
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              {result.message}
              <button
                onClick={() => toast.dismiss(t.id)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'inherit',
                  cursor: 'pointer',
                  fontSize: '16px',
                  marginLeft: '10px'
                }}
              >
                ✕
              </button>
            </span>
          ),
          {
            // Prevent auto-dismissal
            duration: Infinity,
          }
        );
        onClose(); // Close modal on success
      } else {
        toast.error(result.message || "Failed to log complaint");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "An error occurred while logging the complaint";
      console.error("Error logging complaint:", error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData((prev) => ({
      ...initialFormData,
      customerName: prev.customerName,
      city: prev.city,
    }));
    setFormErrors({
      serviceType: "",
      serviceCenterId: "",
      preferredDate: "",
      startTime: "",
      endTime: "",
    });
    setChecked(false);
    setStartTime(null);
    setEndTime(null);
    setServiceCenter([]);
    // onClose();
  };

  return (
    <Box sx={{ ...style, width: "75%", overflow: "auto", maxHeight: "90vh" }}>
      {loading && <Loader />}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h4>Log Product Complaint</h4>
        <IconButton
          onClick={onClose}
          sx={{
            backgroundColor: "#EFF3FE",
            color: "#33499F",
            border: "none",
            borderRadius: "4px",
            padding: "4px",
            "&:hover": {
              backgroundColor: "#EFF3FE",
            },
          }}
        >
          <span style={{ fontSize: "20px", fontWeight: "bolder" }}>✕</span>
        </IconButton>
      </Box>
      <Grid container gap={5}>
        <Grid item>
          <TextField
            style={{ width: "100%" }}
            id="standard-basic"
            label="Customer Name"
            variant="standard"
            value={formData.customerName}
            disabled // Pre-filled and read-only
          />
        </Grid>

        <Grid item>
          <TextField
            style={{ width: "100%" }}
            id="standard-basic"
            label="City"
            variant="standard"
            value={formData.city}
            disabled // Pre-filled and read-only
          />
        </Grid>
        <Grid item>
          <Autocomplete
            id="disable-close-on-select"
            options={jobsheetOptions}
            getOptionLabel={(option) => option.label}
            value={
              jobsheetOptions.find((item) => item.label === formData.jobsheetType) || null
            }
            onChange={(e, value) =>
              handleInputChange("jobsheetType", value?.label)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Jobsheet Type"
                variant="standard"
                style={{ width: "12.5rem" }}
              />
            )}
          />
        </Grid>
      </Grid>

      <Grid container gap={5}>
        <Grid item>
          <Autocomplete
            id="disable-close-on-select"
            options={serviceType}
            getOptionLabel={(option) => option.label}
            value={serviceType.find((item) => item.id === formData.serviceType) || null}
            onChange={(e, value) =>
              handleInputChange("serviceType", value?.id)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Service Type *"
                variant="standard"
                style={{ width: "12.5rem" }}
                error={!!formErrors.serviceType}
                helperText={formErrors.serviceType}
              />
            )}
          />
        </Grid>

        <Grid item>
          <TextField
            style={{ width: "12.5rem" }}
            id="standard-basic"
            label="Fault Observed by Customer"
            variant="standard"
            value={formData.faltObserverByCustomer || ""}
            onChange={(e) => handleInputChange("faltObserverByCustomer", e.target.value)}
          />
        </Grid>
        <Grid item>
          <TextField
            style={{ width: "12.5rem" }}
            id="standard-basic"
            label="Customer Remarks"
            variant="standard"
            value={formData.remarks || ""}
            onChange={(e) => handleInputChange("remarks", e.target.value)}
          />
        </Grid>
      </Grid>
      <Divider
        sx={{
          height: "1px",
          backgroundColor: "gray",
          width: "100%",
          margin: "10px auto",
        }}
      />
      <Box sx={{ width: "100%" }}>
        <h4>Service</h4>
      </Box>
      <Grid container gap={3}>
        <Grid item>
          <TextField
            style={{ width: "80%" }}
            id="standard-basic"
            label="Customer Contact Person"
            variant="standard"
            value={formData.customerContactPerson || ""}
            onChange={(e) =>
              handleInputChange("customerContactPerson", e.target.value)
            }
          />
        </Grid>

        <Grid item>
          <TextField
            style={{ width: "80%" }}
            id="standard-basic"
            label="Contact No."
            variant="standard"
            value={formData.customerContactPersonNumber || ""}
            onChange={(e) => {
              // Only allow numbers and max 10 digits
              const value = e.target.value.replace(/\D/g, "").slice(0, 10);
              handleInputChange("customerContactPersonNumber", value);
            }}
            inputProps={{
              maxLength: 10,
              pattern: "[0-9]*",
              inputMode: "numeric",
            }}
            error={!!formData.contactNumberError}
            helperText={formData.contactNumberError}
          />
        </Grid>
        <Grid item>
          <Box>
            <Calendar
              value={formData.preferredDate}
              handleChange={handlePreferredDateChange}
              fieldName="preferredDate"
              minDate={new Date()}
            />
            {formErrors.preferredDate && (
              <Typography sx={{ color: "#d32f2f", fontSize: "0.75rem", mt: 0.5 }}>
                {formErrors.preferredDate}
              </Typography>
            )}
          </Box>
        </Grid>

        <Grid item>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              {/* Start Time Field */}
              <Grid item xs={4} sm={3}>
                <TimePicker
                  label="Start Time"
                  value={startTime}
                  ampm={false}
                  disabled={!formData.preferredDate}
                  minTime={startTimeMinValue}
                  onChange={handleStartTimeChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      variant="standard"
                      error={!!formErrors.startTime}
                      helperText=" "
                    />
                  )}
                />
                <Typography
                  sx={{ color: "#d32f2f", fontSize: "0.75rem", mt: 0.5, minHeight: "18px" }}
                >
                  {formErrors.startTime || " "}
                </Typography>
              </Grid>

              {/* End Time Field */}
              <Grid item xs={4} sm={3}>
                <TimePicker
                  label="End Time"
                  value={endTime}
                  ampm={false}
                  disabled={!formData.preferredDate || !startTime}
                  minTime={endTimeMinValue}
                  onChange={handleEndTimeChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      variant="standard"
                      error={!!formErrors.endTime}
                      helperText=" "
                    />
                  )}
                />
                <Typography
                  sx={{ color: "#d32f2f", fontSize: "0.75rem", mt: 0.5, minHeight: "18px" }}
                >
                  {formErrors.endTime || " "}
                </Typography>
              </Grid>

              {/* Preferred Time Slot Field */}
              <Grid item xs={12} sm={6}>
                <TextField
                  style={{ width: "100%" }}
                  id="preferredTime"
                  // label="Preferred Time Slot"
                  placeholder="Preferred Time Slot"
                  variant="standard"
                  value={formData.preferredTime}
                  disabled
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 40,
                    },
                  }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
        </Grid>
      </Grid>
      <Grid container gap={2}>
        <Grid item md={3}>
          <Autocomplete
            id="disable-close-on-select"
            options={serviceCenterList}
            getOptionLabel={(option) => option.serviceCenter}
            value={
              serviceCenterList.find((item) => item._id === formData.serviceCenterId) || null
            }
            onChange={(e, value) =>
              handleInputChange("serviceCenterId", value?._id)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Service Center *"
                variant="standard"
                style={{ width: "12.5rem" }}
                error={!!formErrors.serviceCenterId}
                helperText={formErrors.serviceCenterId}
              />
            )}
          />
        </Grid>

        {formData.serviceCenterId && (
          <Grid item md sx={{ marginTop: "20px" }}>
            <Grid container justifyContent={"center"}>
              <p style={{ fontSize: "0.8rem" }}>Note: Service Center Info</p>
            </Grid>

            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 500, fontSize: "12px" }}
                size="small"
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    {modalCell.map((cell, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          color: "white",
                          textAlign: "center",
                          fontSize: "12px",
                        }}
                      >
                        {cell}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {serviceCenter.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center" sx={{ fontSize: "12px" }}>
                        {row.location}
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: "12px" }}>
                        {row.serviceCentreName}
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: "12px" }}>
                        {row.addressLine1}
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: "12px" }}>
                        {row.contact}
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: "12px" }}>
                        {row.email}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}
      </Grid>

      <FormGroup sx={{ marginTop: "30px" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={formData.callClose}
              onChange={(e) => handleInputChange("callClose", e.target.checked)}
            />
          }
          label="Close Call Without Service Engineer"
        />
      </FormGroup>

      {formData.callClose && (
        <Box
          sx={{
            width: "100%",

            "& .MuiTextField-root": { m: 1, width: "25ch" },
          }}
          noValidate
          autoComplete="off"
        >
          <div>
            {formData.callClose && (
              <TextField
                id="outlined-multiline-static"
                label="Solution Provided"
                multiline
                rows={4}
                sx={{ backgroundColor: "white" }}
                onChange={(e) =>
                  handleInputChange("solutionProvided", e.target.value)
                }
              />
            )}
          </div>
        </Box>
      )}
      <Grid container justifyContent={"flex-end"} gap={2}>
        <Grid item>
          <CommonButton name={"Update"} handleOnClick={handleSubmit} />
        </Grid>
        <Grid item>
          <CommonButton name={"Cancel"} handleOnClick={handleReset} />
        </Grid>
      </Grid>
    </Box>
  );
};

const ViewAmcModal = ({ productData, onClose }) => {
  const [amcDetails, setAmcDetails] = useState(null);
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    const fetchAmcDetails = async () => {
      try {
        setLoading(true);
        const params = {
          customerId: productData.customerId,
          productId: productData._id,
        };
        const response = await fetchAMCList(params);

        if (response.status === "error") {
          toast.error("Failed to fetch AMC details");
          setAmcDetails(null);
        } else {
          // Get the most recent AMC if there are multiple
          const currentAmc =
            response.amcs && response.amcs.length > 0 ? response.amcs[0] : null;
          setAmcDetails(currentAmc);
        }
      } catch (error) {
        console.error("Error fetching AMC details:", error);
        toast.error("Error fetching AMC details");
        setAmcDetails(null);
      } finally {
        setLoading(false);
      }
    };

    if (productData && productData._id) {
      fetchAmcDetails();
    }
  }, [productData]);

  if (loading) {
    return <Loader />;
  }

  return (
    <Box sx={{ ...style, width: "75%", maxHeight: "80vh", overflow: "auto" }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h4>AMC Details</h4>
        <IconButton
          onClick={onClose}
          sx={{
            backgroundColor: "#EFF3FE",
            color: "#33499F",
            border: "none",
            borderRadius: "4px",
            padding: "4px",
            "&:hover": {
              backgroundColor: "#EFF3FE",
            },
          }}
        >
          <span style={{ fontSize: "20px", fontWeight: "bolder" }}>✕</span>
        </IconButton>
      </Box>

      <Grid container spacing={3}>
        {/* AMC Details Table */}
        <Grid item xs={12}>
          <TableContainer component={Paper} sx={{ marginBottom: 3 }}>
            <Table size="medium">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#33499F" }}>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Name
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Product
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Warranty In Months
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    AMC
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Start Date
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    End Date
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{productData.customerName || "-"}</TableCell>
                  <TableCell>
                    {`${productData.brandName} ${productData.modelName}` || "-"}
                  </TableCell>
                  <TableCell>
                    {amcDetails?.amcDetails?.duration || "-"}
                  </TableCell>
                  <TableCell>{amcDetails?.amcDetails?.name || "-"}</TableCell>
                  <TableCell>{formatDate(amcDetails?.startDate)}</TableCell>
                  <TableCell>{formatDate(amcDetails?.endDate)}</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        backgroundColor:
                          (amcDetails?.amcStatus || productData.amcStatus) ===
                            "Running"
                            ? "#4CAF50"
                            : "#FFA726",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        display: "inline-block",
                      }}
                    >
                      {amcDetails?.amcStatus || productData.amcStatus || "-"}
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

const Searchdealercustomer = () => {
  const getStoredState = () => {
    const shouldPreserve = sessionStorage.getItem("preserveSearchDealerCustomer") === "true";

    if (!shouldPreserve) {
      return {};
    }

    const stored = sessionStorage.getItem("searchDealerCustomerState");
    try {
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  };
  const storedState = getStoredState();

  const [open, setOpen] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(storedState.selectedCustomerId || null);
  const [selectedCustomer, setSelectedCustomer] = useState(storedState.selectedCustomer || null);
  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  const [openLogComplaintModal, setOpenLogComplaintModal] = useState(false);
  const [selectedCustomerProductId, setSelectedCustomerProductId] = useState(storedState.selectedCustomerProductId || null);
  const [value, setValue] = useState();
  const [tabIndex, setTabIndex] = useState(storedState.tabIndex || 0);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(storedState.tableData || []);
  const [totalRecords, setTotalRecords] = useState(storedState.totalRecords || 0);
  const [tableDataProduct, setTableDataProduct] = useState(storedState.tableDataProduct || []);
  const [totalRecordsProduct, setTotalRecordsProduct] = useState(storedState.totalRecordsProduct || 0);
  const [loading, setLoading] = useState(false);
  const [showProductDetails, setShowProductDetails] = useState(storedState.showProductDetails || false);
  const [callHistory, setCallHistory] = useState(storedState.callHistory || []);
  const [formData, setFormData] = useState({
    customerName: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    landmark: "",
    gstNumber: "",
  });
  const [openViewAmcModal, setOpenViewAmcModal] = useState(false);
  const [selectedAmcProduct, setSelectedAmcProduct] = useState(null);

  const handleClose = () => {
    setOpen(false);
    setOpenCustomerModal(false);
    setOpenLogComplaintModal(false);
    // Reset forms when closing modals
    setFormData({
      customerName: "",
      mobileNumber: "",
      email: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      landmark: "",
      gstNumber: "",
    });
  };

  const [searchParams, setSearchParams] = useState(storedState.searchParams || {
    customerName: "",
    email: "",
    mobileNumber: "",
  });

  useEffect(() => {
    // Consume the preserve flag on mount so it doesn't linger for future navigations
    const shouldPreserve = sessionStorage.getItem("preserveSearchDealerCustomer") === "true";
    if (shouldPreserve) {
      sessionStorage.removeItem("preserveSearchDealerCustomer");
    } else {
      // If we didn't land here with a preserve flag, ensure the global cache is cleared
      sessionStorage.removeItem("searchDealerCustomerState");
    }
  }, []);

  useEffect(() => {
    const stateToSave = {
      tableData,
      totalRecords,
      searchParams
    };
    sessionStorage.setItem("searchDealerCustomerState", JSON.stringify(stateToSave));
  }, [tableData, totalRecords, searchParams]);

  // Add validation errors state
  const [validationErrors, setValidationErrors] = useState({
    customerName: "",
    email: "",
    mobileNumber: "",
  });

  // Email validation function
  const validateEmail = (email) => {
    if (!email) return "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) ? "" : "Invalid email format";
  };

  // Contact number validation function
  const validateMobileNumber = (number) => {
    if (!number) return "";
    if (!/^\d*$/.test(number)) return "Only numeric values are allowed";
    if (number.length >= 10) return "Maximum 10 digits allowed";
    return "";
  };

  // Name validation function
  const validateCustomerName = (name) => {
    if (!name) return "";
    if (name.length >= 25) return "Maximum 25 characters allowed";
    return "";
  };

  const fetchCustomerDetails = async () => {
    // Check if any search params are provided
    const hasSearchParams = Object.values(searchParams).some(
      (value) => value.trim() !== ""
    );
    if (!hasSearchParams) {
      // Don't make API call if no search params
      setTableData([]);
      setTotalRecords(0);
      return;
    }

    setLoading(true);
    try {
      const response = await customers(searchParams);
      if (!response || response.status !== "success") {
        throw new Error(response?.message || "Failed to fetch customer data");
      }

      if (!response.data?.customers?.length) {
        setTableData([]);
        setTotalRecords(0);
        toast.info("No customers found");
        return;
      }

      setTableData(
        response.data.customers.map((customer) => ({
          ...customer,
          customerId: customer._id,
        }))
      );
      setTotalRecords(response.data.totalCustomers || 0);
    } catch (error) {
      console.error("Error in fetchCustomerDetails:", error);
      setTableData([]);
      setTotalRecords(0);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Error fetching customer details"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (fieldName, value) => {
    // Validate input before updating state
    let error = "";
    let updatedValue = value;

    if (fieldName === "email") {
      error = validateEmail(value);
    } else if (fieldName === "mobileNumber") {
      // For mobile number, restrict to 10 digits
      if (value.length > 10) {
        updatedValue = value.slice(0, 10);
        error = "Maximum 10 digits allowed";
      } else if (!/^\d*$/.test(value)) {
        error = "Only numeric values are allowed";
      }
    } else if (fieldName === "customerName") {
      // For customer name, restrict to 25 characters
      if (value.length > 25) {
        updatedValue = value.slice(0, 25);
        error = "Maximum 25 characters allowed";
      }
    }

    // Update search params with potentially truncated value
    setSearchParams((prev) => ({
      ...prev,
      [fieldName]: updatedValue,
    }));

    // Update validation errors
    setValidationErrors((prev) => ({
      ...prev,
      [fieldName]: error,
    }));
  };

  const handleSearchCustomer = async (event) => {
    event.preventDefault();

    // Check for validation errors before submitting
    const hasErrors = Object.values(validationErrors).some(error => error !== "");
    if (hasErrors) {
      toast.error("Please fix the validation errors before searching");
      return;
    }

    const nonEmptyParams = Object.fromEntries(
      Object.entries(searchParams).filter(([_, value]) => value.trim() !== "")
    );

    if (Object.keys(nonEmptyParams).length === 0) {
      toast.error(
        "Please provide at least one required field (Email, Customer Name or Contact Number)"
      );
      return;
    }

    setLoading(true);
    // Reset all tables and selected states on new search
    setTableData([]);
    setTotalRecords(0);
    setTableDataProduct([]);
    setTotalRecordsProduct(0);
    setCallHistory([]);
    setShowProductDetails(false);
    setTabIndex(0);
    setSelectedCustomerId(null);
    setSelectedCustomer(null);
    setSelectedCustomerProductId(null);

    try {
      const response = await customers(nonEmptyParams);

      // Clear both tables if no customers found or if there's an error
      if (
        !response ||
        response.status !== "success" ||
        !response.data?.customers?.length
      ) {
        // Clear customer table
        setTableData([]);
        setTotalRecords(0);

        // Clear product table
        setTableDataProduct([]);
        setTotalRecordsProduct(0);

        // Show appropriate message
        if (!response || response.status !== "success") {
          toast.error(response?.message || "Failed to fetch customer data");
        } else {
          toast.info("No customers found");
        }
        return;
      }

      // If customers found, update customer table
      setTableData(
        response.data.customers.map((customer) => ({
          ...customer,
          customerId: customer._id,
        }))
      );
      setTotalRecords(response.data.totalCustomers || 0);
      toast.success(response.message || "Data fetched successfully");
    } catch (error) {
      console.error("Error fetching customer data:", error);

      // Clear both tables on error
      setTableData([]);
      setTotalRecords(0);
      setTableDataProduct([]);
      setTotalRecordsProduct(0);

      toast.error(
        error.response?.data?.message ||
        error.message ||
        "An error occurred while fetching customer data"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    // Reset search parameters
    setSearchParams({
      customerName: "",
      email: "",
      mobileNumber: "",
    });

    // Reset validation errors
    setValidationErrors({
      customerName: "",
      email: "",
      mobileNumber: "",
    });

    // Reset table data
    setTableData([]);
    setTotalRecords(0);
    setTableDataProduct([]);
    setTotalRecordsProduct(0);

    // Reset selected states
    setSelectedCustomerId(null);
    setSelectedCustomer(null);
    setSelectedCustomerProductId(null);
    setShowProductDetails(false);

    // Reset tab state
    setTabIndex(0);

    // Reset form data
    setFormData({
      customerName: "",
      mobileNumber: "",
      email: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      landmark: "",
      gstNumber: "",
    });

    // Clear any stored customer ID and stored states
    localStorage.removeItem("customerId");
    sessionStorage.removeItem("searchDealerCustomerState");
  };

  const handleSearchProduct = async (customerId) => {
    if (!customerId) {
      toast.error("Customer ID is required to search products");
      return;
    }
    setLoading(true);
    // Reset product and history data before fetching new ones
    setTableDataProduct([]);
    setTotalRecordsProduct(0);
    setCallHistory([]);
    setShowProductDetails(true);

    try {
      await getCallHistory(customerId, true);
      const queryParams = { customerId };
      const response = await customerProduct(queryParams);

      if (!response || response.status !== "success") {
        throw new Error(response?.message || "Failed to fetch product data");
      }

      if (!response.data?.products?.length) {
        setTableDataProduct([]);
        setTotalRecordsProduct(0);
        toast.info("No products found for this customer");
        return;
      }

      setTableDataProduct(response.data.products);
      setTotalRecordsProduct(response.data.totalProducts || 0);
      toast.success("Products fetched successfully");
    } catch (error) {
      console.error("Error fetching product data:", error);
      setTableDataProduct([]);
      setTotalRecordsProduct(0);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch product data"
      );
    } finally {
      setLoading(false);
    }
  };

  const getCallHistory = async (customerId, skipLoading = false) => {
    try {
      if (!skipLoading) setLoading(true);
      const params = {
        customerId: customerId,
      }
      const response = await fetchJobsheetSearchList(params);
      if (response.status === "success") {
        setCallHistory(response.data.jobSheets);
        // setTotalRecords(response.data.pagination.totalRecords);
      } else {
        setCallHistory([]);
        // toast.error(response.message)
      }
    } catch (error) {
      console.error("Error fetching jobsheet search list:", error);
      setCallHistory([]);
      // toast.error(error.response?.data?.message || "Error fetching call history")
    } finally {
      if (!skipLoading) setLoading(false);
    }
  };

  const handleOpen = (customerId) => {
    setSelectedCustomerId(customerId); // Store the selected customerId
    setOpen(true);
  };

  const handleCustomerModal = (customer) => {
    setSelectedCustomer(customer); // Set the selected customer's data
    setOpenCustomerModal(true);
  };

  const handleLogComplaintModal = (customerId, customerProductId) => {
    if (!customerId || typeof customerId !== "string") {
      console.error("Invalid customerId. Ensure it's a valid string.");
      return;
    }

    if (!customerProductId || typeof customerProductId !== "string") {
      console.error("Invalid customerProductId. Ensure it's a valid string.");
      return;
    }

    setSelectedCustomerId(customerId); // Store customerId in state
    setSelectedCustomerProductId(customerProductId); // Store productId in state
    setOpenLogComplaintModal(true); // Open the modal
  };

  const handleAMC = (productData) => {
    if (productData.amcStatus === "Running") {
      // Show modal for viewing AMC
      setSelectedAmcProduct(productData);
      setOpenViewAmcModal(true);
    } else {
      // Create a modified object that maps _id to productId
      const dataToStore = {
        ...productData,
        productId: productData._id,
      };

      // Store the modified product data in localStorage
      localStorage.setItem("amcProductData", JSON.stringify(dataToStore));
      // Set preservation flag specifically for returning from CreateCustomerAmc
      sessionStorage.setItem("preserveSearchDealerCustomer", "true");
      // Navigate in the same tab
      navigate("/CreateCustomerAmc");
    }
  };

  const handleCreateCustomerButton = () => {
    navigate("/Customerservice");
  };

  const handleTabChange = (index) => {
    setTabIndex(index);
  };

  return (
    <Grid container>
      <HeaderNavigation value={"Search Customer"} location={""} />
      <DynamicTabs />
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          margin: "4px 10px 0 10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px 10px 10px 10px",
          fontWeight: 600,
        }}
      >
        <Grid container>
          <Grid item sm={6} md={4}>
            <TextField
              id="standard-basic"
              label="Email"
              variant="standard"
              value={searchParams.email}
              onChange={(e) => handleSearchChange("email", e.target.value)}
              error={!!validationErrors.email}
              helperText={validationErrors.email}
            />
          </Grid>
          <Grid item sm={6} md={4}>
            <TextField
              id="standard-basic"
              label="Contact No."
              variant="standard"
              value={searchParams.mobileNumber}
              onChange={(e) =>
                handleSearchChange("mobileNumber", e.target.value)
              }
              error={!!validationErrors.mobileNumber}
              helperText={validationErrors.mobileNumber}
              inputProps={{
                maxLength: 10,
                pattern: "[0-9]*",
                inputMode: "numeric",
              }}
            />
          </Grid>
          <Grid item sm={6} md={4}>
            <TextField
              id="standard-basic"
              label="Customer Name"
              variant="standard"
              value={searchParams.customerName}
              onChange={(e) =>
                handleSearchChange("customerName", e.target.value)
              }
              error={!!validationErrors.customerName}
              helperText={validationErrors.customerName}
              inputProps={{
                maxLength: 25,
              }}
            />
          </Grid>
        </Grid>
        <Grid container gap={5} sx={{ marginTop: "1rem" }}>
          <Grid item>
            <CommonButton
              name={"Search"}
              handleOnClick={handleSearchCustomer}
            />
          </Grid>
          <Grid item>
            <CommonButton name={"Reset"} handleOnClick={handleReset} />
          </Grid>
          <Grid item sx={{ marginLeft: "auto" }}>
            <CommonButton
              name={"Create Customer"}
              handleOnClick={handleCreateCustomerButton}
            />
          </Grid>
        </Grid>
      </Grid>
      {/* Customer Details */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          margin: "4px 10px 0 10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px 10px 10px 10px",
          fontWeight: 600,
        }}
      >
        <Grid container>
          <Subheader heading={"Customer Details"} />
        </Grid>
        <Grid container gap={5} sx={{ marginTop: "1rem" }}>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {customerCells.map((cell, index) => (
                    <TableCell
                      key={index}
                      sx={{ color: "white", textAlign: "center" }}
                    >
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {tableData.length > 0 ? (
                  tableData.map((row, index) => {
                    return (
                      <TableRow key={row.customerId || index}>
                        <TableCell align="center">{row.customerName}</TableCell>
                        <TableCell align="center">{row.state}</TableCell>
                        <TableCell align="center">{row.city}</TableCell>
                        <TableCell align="center">{row.mobileNumber}</TableCell>
                        <TableCell align="center">{row.address}</TableCell>
                        <TableCell align="center">{row.email}</TableCell>
                        <TableCell align="center">
                          <CommonButton
                            name="Edit"
                            handleOnClick={() => handleCustomerModal(row)}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <CommonButton
                            name="AddProduct"
                            handleOnClick={() => handleOpen(row.customerId)}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <CommonButton
                            name="View"
                            handleOnClick={() =>
                              handleSearchProduct(row.customerId)
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={customerCells.length}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      {/* customer Product and Call history table */}
      {showProductDetails && (
        <Grid
          container
          sx={{
            background: "#EFF3FE",
            margin: "4px 10px 0 10px",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
            width: "100%",
            borderRadius: "5px",
            padding: "10px 10px 10px 10px",
            fontWeight: 600,
          }}
        >
          <Grid container spacing={2}>
            {/* Tabs */}
            <Grid item>
              <Typography
                onClick={() => handleTabChange(0)}
                sx={{
                  cursor: "pointer",
                  color: tabIndex === 0 ? "#33499F" : "gray",
                  fontWeight: tabIndex === 0 ? "bold" : "normal",
                  fontSize: "16px",
                }}
              >
                Product Details
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                onClick={() => handleTabChange(1)}
                sx={{
                  cursor: "pointer",
                  color: tabIndex === 1 ? "#33499F" : "gray",
                  fontWeight: tabIndex === 1 ? "bold" : "normal",
                  fontSize: "16px",
                }}
              >
                Call History
              </Typography>
            </Grid>
          </Grid>
          <Grid container gap={5} sx={{ marginTop: "1rem" }}>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    {tabIndex === 0
                      ? productCells.map((cell, index) => (
                        <TableCell
                          key={index}
                          sx={{ color: "white", textAlign: "center" }}
                        >
                          {cell}
                        </TableCell>
                      ))
                      : callCells.map((cell, index) => (
                        <TableCell
                          key={index}
                          sx={{ color: "white", textAlign: "center" }}
                        >
                          {cell}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {tabIndex === 0 ? (
                    // Product Details Tab
                    tableDataProduct.length > 0 ? (
                      tableDataProduct.map((row, index) => (
                        <TableRow key={row._id || index}>
                          <TableCell align="center">{row.brandName}</TableCell>
                          <TableCell align="center">{row.categoryName}</TableCell>
                          <TableCell align="center">
                            {row.subcategoryName}
                          </TableCell>
                          <TableCell align="center">{row.modelName}</TableCell>
                          <TableCell align="center">{formatAnyDateToDisplay(row.invoiceDate, "-")}</TableCell>
                          <TableCell align="center">{row.invoiceNo}</TableCell>
                          <TableCell
                            align="Center"
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                            }}
                          >
                            {row.amcStatus === "Running" ? (
                              <CommonButton
                                name={"View AMC"}
                                handleOnClick={() => handleAMC(row)}
                              />
                            ) : (
                              <CommonButton
                                name={"Create AMC"}
                                handleOnClick={() => handleAMC(row)}
                              />
                            )}
                            &nbsp; &nbsp; &nbsp;
                            <IconButton
                              onClick={() =>
                                handleLogComplaintModal(row.customerId, row._id)
                              }
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                                height: "40px",
                                width: "40px",
                                paddingLeft: "auto",
                              }}
                            >
                              <Tooltip title="Log Complain" arrow>
                                <img
                                  src={LogcomplaintIcon}
                                  alt="active"
                                  style={{ height: "100%", width: "100%" }}
                                />
                              </Tooltip>
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell align="center" colSpan={productCells.length}>
                          No data available
                        </TableCell>
                      </TableRow>
                    )
                  ) : (
                    // Call History Tab
                    callHistory.length > 0 ? (
                      callHistory.map((row, index) => (
                        <TableRow key={row._id || index}>
                          <TableCell align="center">{formatAnyDateToDisplay(row.jobsheetDate, "-")}</TableCell>
                          <TableCell align="center">{row.jobSheetNo}</TableCell>
                          <TableCell align="center">{row._id}</TableCell>
                          <TableCell align="center">{row.productCategory}</TableCell>
                          <TableCell align="center">{row.modelName}</TableCell>
                          <TableCell align="center">{row.sku || '-'}</TableCell>
                          <TableCell align="center">{row.contactPerson}</TableCell>
                          <TableCell align="center">{row.jobSheetStatus}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell align="center" colSpan={callCells.length}>
                          No call history available
                        </TableCell>
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      )}

      {/* Product details modal */}
      <Modal
        open={open}
        onClose={() => { }} // Disable default close behavior
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <ProductModal
          customerId={selectedCustomerId}
          onClose={handleClose}
          handleSearchProduct={handleSearchProduct}
        />
      </Modal>

      {/* Edit Customer Details */}
      <Modal
        open={openCustomerModal}
        onClose={() => { }} // Disable default close behavior
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <CustomerModal
          customerData={selectedCustomer}
          isEdit={!!selectedCustomer}
          onUpdate={() => {
            handleClose();
            fetchCustomerDetails();
          }}
          onClose={handleClose}
        />
      </Modal>
      {/* Log Complaint */}
      <Modal
        open={openLogComplaintModal}
        onClose={() => { }} // Disable default close behavior
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <LogComplaintModal
          customerId={selectedCustomerId}
          customerProductId={selectedCustomerProductId}
          amcStatus={tableDataProduct.find(product => product._id === selectedCustomerProductId)?.amcStatus}
          onClose={handleClose}
        />
      </Modal>
      {/* View AMC Modal */}
      <Modal
        open={openViewAmcModal}
        onClose={() => setOpenViewAmcModal(false)}
        aria-labelledby="view-amc-modal"
        aria-describedby="view-amc-details"
      >
        <ViewAmcModal
          productData={selectedAmcProduct}
          onClose={() => setOpenViewAmcModal(false)}
        />
      </Modal>
      <Toaster />
      {loading && <Loader />}
    </Grid>
  );
};

export default Searchdealercustomer;
